
import * as React from 'react';
import configData from "../config.json";

import { RouteComponentProps } from 'react-router';
import {
    Card, CardHeader, CardBody, Row, Col, FormGroup, CustomInput,
    Label, Input, InputGroup, InputGroupAddon, Button
} from 'reactstrap';

import { alertService } from 'components/Varios/alert_service.js';
import Icon from "components/Varios/Icons.js";
import SelectCreate from "components/Varios/SelectCreate.js";
import SelectItem from "components/Varios/select.js";
import Datepicker from "components/Varios/Datepicker.js";
import CardMiembroOrganizacion from "components/Varios/CardMiembroOrganizacion.js";

import FileUpload from "components/Varios/FileUpload.js";
import FileDownload from "components/Varios/FileDownload.js";

import InputFileDownload from "components/Varios/InputFileDownload.js";
import InputFileUpload from "components/Varios/InputFileUpload.js";

import { authenticationService } from '../services/authentication.service';
import { mensajeCamposIncompletos } from './constants';

const id = 1043;
const API_URL = configData.SERVER_URL

export class MiembroOrganizacionData {
    idafiliacionpersonal: number = 0;
    idpersona: number = 0;

    fecha: string = "";
    idpais: number = 0;

    institucion: string = "";
    tipo: string = "M";
    estado: string = "A";
}


interface MiembroOrganizacionDataState {
    currentUser: any;
    loading: boolean;
    loadingList: boolean;
    dtoData: MiembroOrganizacionData;
    MiembroOrganizacionDataList: MiembroOrganizacionData[];
    paisList: Array<any>;
    error: null,
    tiposEvidencia: Array<any>;
    filesData: Array<any>;
}

export class MiembroOrganizacion extends React.Component<RouteComponentProps<{}>, MiembroOrganizacionDataState> {
    constructor(props) {
        super(props);
        this.state = {
            currentUser: authenticationService.currentUserValue, loading: true, loadingList: true, dtoData: new MiembroOrganizacionData(),
            MiembroOrganizacionDataList: [], paisList: [], error: null, tiposEvidencia: [], filesData: []
        };

        this.cargarDatos = this.cargarDatos.bind(this);
        this.cargarMiembroOrganizacion = this.cargarMiembroOrganizacion.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        //this.handleFileUploadChange = this.handleFileUploadChange.bind(this);
    }

    componentDidMount() {
        authenticationService.currentUser.subscribe(
            (x) => {
                this.setState({
                    currentUser: x
                });
                if (x && x.token) {
                    this.cargarDatos();
                    this.cargarMiembroOrganizacion();
                }
            }
        );
    }

    componentWillUnmount() {
        alertService.clear();
    }

    cargarDatos() {
        //API PARA OBTENER PAISES
        fetch(API_URL + "DatosEscalafon/Paises")
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            paisList: result.entTabla.map(d => ({
                                "value": d.idpais,
                                "label": d.nombre
                            })),
                        });
                    } else {
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener los paises.")
                    }
                },
                (error) => {

                    this.setState({
                        loading: false,
                        error,
                        paisList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )
    }

    //API PARA OBTENER INFORMACIÓN ACADÉMICA DE PERSONA
    cargarMiembroOrganizacion() {
        fetch(API_URL + "DatosEscalafon/MiembroOrganizacionDescByIdpersona/" + this.state.currentUser.idpersona)
            .then(res => res.json())
            .then(
                (result) => {
                    //console.log(result)
                    if (result.strEstado === "S") {
                        this.setState({
                            MiembroOrganizacionDataList: result.entTabla,
                            loading: false,
                            loadingList: false,
                            //tiposEvidencia: this.cargarEvidencias(null)
                        });
                    } else {
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener la información académica.")
                    }
                },
                (error) => {
                    
                    this.setState({
                        loading: false,
                        error,
                        MiembroOrganizacionDataList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )
    }

    handleChange(event) {
        var dto = this.state.dtoData;
        dto[event.target.name] = event.target.value;
        this.setState({
            dtoData: dto,
            loading: false
        })
    }

    handleSelectChange(value, name) {
        var dto = this.state.dtoData;
        dto[name] = value;

        this.setState({
            dtoData: dto,
        });
    }

    //handleFileUploadChange(tipoEvidencia, uploadFile) {
    //    const src = window.URL.createObjectURL(uploadFile);
    //    const fileInfo = { type: tipoEvidencia, file: uploadFile, id: tipoEvidencia, src: src };
    //    let fileInfoState = this.state.filesData.slice();
    //    let fileInfoStateFiltrado = fileInfoState.filter(f => f.type !== fileInfo.type);
    //    fileInfoState = fileInfoStateFiltrado.concat(fileInfo);

    //    this.setState({
    //        filesData: fileInfoState,
    //    });

    //}

    //cargarEvidencias(tipoEvidencia) {
    //    var tiposEvidencia = [{ "value": "EAC", "label": "Certificado de asociación profesional" }];
    //    //console.log("cargarEvidencias: tiposEvidencia=" + tiposEvidencia.map(te => te.value + " => " + te.label).join(", "));
    //    return tiposEvidencia;
    //}

    //descargarEvidencias(infoAcademica: MiembroOrganizacionData) {
    //    var evidencias = new Array();
    //    if (infoAcademica.refarchivo) {
    //        evidencias.push({ name: "EAC" + infoAcademica.idpersona + ".PDF", url: API_URL + "InformacionAcademica/Mencionhonor/Refarchivo/" + infoAcademica.idafiliacionpersonal });
    //    }
    //    return evidencias;
    //}

    onClickLimpiar() {
        this.setState({ dtoData: new MiembroOrganizacionData()});
    }

    onClickEdit(idafiliacionpersonal) {
        this.setState({
            dtoData: new MiembroOrganizacionData()
        });

        fetch(API_URL + "DatosEscalafon/MiembroOrganizacionById/" + idafiliacionpersonal)
            .then(res => res.json())
            .then(
                (result) => {
                    //console.log(result)
                    if (result.strEstado === "S") {

                        this.setState({
                            dtoData: result.entTabla[0],
                            //tiposEvidencia: this.cargarEvidencias(null),
                            loading: false
                        });

                        let myDiv = document.getElementById('main-panel')!;
                        myDiv.scrollTo(0, 0);

                    } else {
                        alertService.error(result["strMensaje"])
                    }

                },
                (error) => {
                    
                    this.setState({
                        loading: false,
                        error,
                        dtoData: new MiembroOrganizacionData()
                    });
                    alertService.error("Ocurrió un error")
                }
            )
    }

    onClickDelete(idafiliacionpersonal) {
        fetch(API_URL + "FormularioController/DeleteDatosMiembroOrganizacion/" + idafiliacionpersonal, {

            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },

        })
            .then(response => response.json())
            .then(
                (responseJson) => {
                    if (responseJson["strEstado"] === "N") {
                        alertService.error(responseJson["strMensaje"])
                    }
                    else {
                        alertService.success("La información académica se eliminó correctamente.")
                        this.cargarMiembroOrganizacion();
                    }
                })
    }

    private handleSave(event) {
        event.preventDefault();
        const forma = new FormData(event.target);
        var dto = this.state.dtoData;
        var filesData = this.state.filesData;
        let formIsValid = true;
        let errors = "";

        forma.forEach((value, clave) => {
            if (!value && clave !== "evidencias") {
                formIsValid = false;
                errors = "Por favor seleccione todos los campos. "
            }

            if (typeof dto[clave] === 'number') {
                dto[clave] = Number(value);
            }
            else if (typeof dto[clave] === 'boolean') {
                dto[clave] = Boolean(value);
            }
            else
                dto[clave] = value;

            if (clave === 'fecha') {
                value = String(value)
                var info = value.split('/').reverse().join('-');
                var date = new Date(String(info))
                dto[clave] = date.toJSON();
            }

        });

        dto.idpersona = this.state.currentUser.idpersona;

        const data = JSON.stringify({
            "entidad": dto,
        });

        //console.log(data)

        if (formIsValid) {
            if (dto.idafiliacionpersonal === 0) {
                fetch(API_URL + "FormularioController/PostDatosMiembroOrganizacion", {

                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: data,

                })
                    .then(response => response.json())
                    .then(
                        (responseJson) => {
                            if (responseJson["strEstado"] === "N") {
                                alertService.error(mensajeCamposIncompletos())
                            }
                            else if (responseJson["strEstado"] === "S") {

                                alertService.success("La asociación profesional se ha registrado correctamente.")

                                //if (filesData.length > 0) {
                                //    var formFilesData = new FormData();

                                //    filesData.map((fileData) => {
                                //        formFilesData.append(fileData.type, fileData.file, fileData.file.name);
                                //    });

                                //    formFilesData.append('idafiliacionpersonal', responseJson.teducacionformal.idafiliacionpersonal);

                                //    fetch(API_URL + "FormularioController/PostFilesDatosMiembroOrganizacion", {
                                //        method: 'POST',
                                //        body: formFilesData
                                //    })
                                //        .then(response => response.json())
                                //        .then(success => {
                                //            // Do something with the successful response
                                //        })
                                //        .catch(error => //console.log(error));
                                //}
                                this.cargarMiembroOrganizacion();
                                this.onClickLimpiar();
                            }
                            else {
                                alertService.error("Ocurrió un error: " + responseJson)
                            }

                        },
                        (error) => {
                            alertService.error("Ocurrió un error: " + error)
                        })
            }
            else {
                fetch(API_URL + "FormularioController/PutDatosMiembroOrganizacion", {

                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json' },
                    body: data,

                })
                    .then(response => response.json())
                    .then(
                        (responseJson) => {
                            if (responseJson["strEstado"] === "N") {
                                alertService.error(responseJson["strMensaje"])

                            }
                            else if (responseJson["strEstado"] === "S") {
                                alertService.success("La asociación profesional se ha actualizado correctamente.")
                                //if (filesData.length > 0) {
                                //    var formFilesData = new FormData();

                                //    filesData.map((fileData) => {
                                //        formFilesData.append(fileData.type, fileData.file, fileData.file.name);
                                //    });

                                //    formFilesData.append('idafiliacionpersonal', responseJson.teducacionformal.idafiliacionpersonal);

                                //    fetch(API_URL + "FormularioController/PostFilesDatosMiembroOrganizacion", {
                                //        method: 'POST',
                                //        body: formFilesData
                                //    })
                                //        .then(response => response.json())
                                //        .then(success => {
                                //            // Do something with the successful response
                                //        })
                                //        .catch(error => //console.log(error));
                                //}
                                this.onClickLimpiar();
                                this.cargarMiembroOrganizacion();

                            }
                            else {
                                alertService.error("Ocurrió un error: " + responseJson)
                            }

                        }
                        , (error) => {
                            alertService.error("Ocurrió un error: " + error)
                        }
                    )
            }
        }
        else {
            alertService.error("Ocurrió un error: " + errors);
        }

    }

    public render() {

        let contents = this.state.loading || !this.state.currentUser.roles.includes("DOCENTEGRADO,")

            ? <div style={{ textAlign: "center" }}>
                <i className="fas fa-sync fa-spin"></i>
                <em> Cargando</em>
            </div>

            : this.renderForm(this.state.MiembroOrganizacionDataList, this.state.paisList, this.state.tiposEvidencia);
        return <div className="content">

            {contents}

        </div>;

    }

    // Returns the HTML Form to the render() method.  

    private renderForm(MiembroOrganizacionDataList: Array<any>, paisList: Array<any>, tiposEvidencia: Array<any>) {

        return (
            <>
                <Row>
                    <Col md={12}>
                        <Card className="principal">
                            <CardHeader>
                                <h5 className="title">Miembro de Asociación Profesional</h5>
                            </CardHeader>
                            <CardBody className="main-content">
                                <div>
                                    <form onSubmit={this.handleSave}>
                                        <Row form>
                                            <Col md={7}>
                                                <FormGroup>
                                                    <Label for="institucion">Asociación*</Label>
                                                    <Input maxLength="150" name="institucion" id="institucion" value={this.state.dtoData.institucion} onChange={this.handleChange} required />
                                                </FormGroup>
                                            </Col>
                                            <Col md={2}>
                                                <Label for="fecha">Fecha*</Label>
                                                <Datepicker
                                                    value={this.state.dtoData.fecha}
                                                    name="fecha"
                                                    id="fecha"
                                                    onChange={this.handleSelectChange}
                                                />
                                            </Col>
                                            <Col md={3}>
                                                <FormGroup>
                                                    <Label for="idpais">País*</Label>
                                                    <SelectItem
                                                        options={paisList}
                                                        value={this.state.dtoData.idpais}
                                                        onChange={this.handleSelectChange}
                                                        placeholder=""
                                                        name="idpais"
                                                        id="idpais"
                                                        icon="pais"
                                                    />
                                                </FormGroup>
                                            </Col>

                                        </Row>

                                        <Row form>
                                            <Col md={12}>
                                                <FormGroup>
                                                    <Button color="primary" type="button" className="btn btn-default" style={{ float: "right" }} onClick={() => this.onClickLimpiar()}>Limpiar</Button>
                                                    <Button color="secondary" type="submit" className="btn btn-default" style={{ float: "right" }}>Guardar</Button>
                                                </FormGroup>
                                            </Col>
                                        </Row>

                                    </form >
                                </div>
                                <br />
                                <div>
                                    {(this.state.loadingList ?
                                        <div style={{ textAlign: "center" }}>
                                            <i className="fas fa-sync fa-spin"></i>
                                            <em> Cargando</em>
                                        </div>
                                        :
                                        <Row id="lista">
                                            {MiembroOrganizacionDataList.map((dto, index) =>
                                                <CardMiembroOrganizacion
                                                    key={dto.idafiliacionpersonal}
                                                    objeto={dto}
                                                    //evidencias={this.descargarEvidencias(dto)}
                                                    number={(index + 1) + " / " + MiembroOrganizacionDataList.length}
                                                    eventEdit={() => this.onClickEdit(dto.idafiliacionpersonal)}
                                                    eventDelete={() => this.onClickDelete(dto.idafiliacionpersonal)}
                                                />
                                            )}
                                        </Row>
                                    )}
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

            </>
        );
    }
}

export default MiembroOrganizacion;